import React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import LandingPage from "./LandingPage";
import GetStartedPage from "./GetStartedPage";
import SignUpPage from "./SignUpPage";
import OTPPage from "./OTPPage";
import AccountPage from "./AccountPage";
import TermsOfServicePage from "./TermsOfService";
import PageNotFoundPage from "./PageNotFoundPage";

const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/get-started", element: <GetStartedPage /> },
  { path: "/sign-up", element: <SignUpPage /> },
  { path: "/otp", element: <OTPPage /> },
  { path: "/manage-account", element: <AccountPage /> },
  { path: "/terms-and-conditions", element: <TermsOfServicePage /> },
  { path: "/page-not-found", element: <PageNotFoundPage /> },
]);

const container = document.getElementById("mount")!;
createRoot(container).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
